import React, { FC } from 'react'
import {Col, Row} from 'antd'

import { financial } from '../../../../services/helper'

import './index.scss';
import SvgPanelClose from "assets/images/icons/SvgPanelClose";
import { useTranslation } from 'react-i18next';

interface RowItemProps {
    label: string;
    text: string;
}

interface RowProps {
    // tableData: Deposit
    leftItems: RowItemProps[];
    tableData: RowItemProps[];
    handleRowClose: any
    labelStyle?: string
    styleCreditRowColum?: object
    styleCreditRowColumLeft?: object
}

export const CreditRowItem: FC<RowProps> = ({ labelStyle, tableData, handleRowClose, styleCreditRowColum, styleCreditRowColumLeft }: RowProps) => {
    const {t} = useTranslation();
    return (
        <div className={`creditRow`}>
        <Row>
        <Col span={12}>
            <div className={`creditRow__colum`} style={styleCreditRowColum}>
                <div key={1} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("accounts.branch")}</p>
                    <p className={'creditRow__colum-item--text'}>{t("home.customerServiceDepartment")}</p>
                </div>
                <div key={2} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("deposit.termMonth")}</p>
                    <p className={'creditRow__colum-item--text'}>{Number(tableData?.periodYear)*12 + Number(tableData?.periodMonth)}</p>
                </div>
                <div key={3} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("deposit.initialAmount")}</p>
                    <p className={'creditRow__colum-item--text'}>{financial(tableData?.INITIALAMOUNT)}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("deposit.amountIncomeTax")}</p>
                    <p className={'creditRow__colum-item--text'}>0.00</p>
                </div>
            </div>
            </Col>
            <Col offset={2} span={11}>
            <div className={'creditRow__colum'} style={styleCreditRowColumLeft}>
                
                <div key={1} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("deposit.interestPaymentScheme")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.PAYMENTPERIOD}</p>
                </div>
                <div key={2} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("deposit.accountInterestTransfer")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData.INTEREST_ACC}</p>
                </div>
                <div key={3} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("deposit.accruedInterestAmount")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData.totalIntCalcAmount ? financial(tableData.totalIntCalcAmount) : '0.00'}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{`${t("credits.paidInterestAmount.up")} ${t("credits.paidInterestAmount.down")}`}</p>
                    {/* <p className={'creditRow__colum-item--text'}>{tableData.totalIntPaidAmount ? financial(tableData.totalIntPaidAmount) : '0.00' }</p> */}
                </div>
                        
            </div>
            </Col>
            </Row>
            <a onClick={() => handleRowClose()} className={'creditRow__closeBtn'}><SvgPanelClose/></a>
        </div>
     
    );
};
